import React, {useEffect, useState} from 'react';
import axios from 'axios';
import { useParams, useNavigate, Link, useLocation } from 'react-router-dom';
import imgTraffic from '../img/Traffic.png';
import imgSmartship from '../img/Smartship.png';
import imgSvessel from '../img/Svessel.png';
import imgCompHeader from '../img/Header.png';
import imgCompFooter from '../img/Footer.png';
import Header from '../../../common/Header_White_Base.js'
import Footer from  '../../../common/Footer.js'
// import imgCompInfo1 from '../img/비즈니스1.png';
// import imgCompInfo2 from '../img/비즈니스2.png';
// import imgCompInfo3 from '../img/비즈니스3.png';
import imgTest from '../img/Test.png';
import Text from '../../../common/Text.js'
// import {Button, Form, FormControl, Nav, Navbar, NavDropdown, } from "react-bootstarp";
import '../../CompanyInfo/css/CompInfo.css'


function CompInfo() {
    /*Header 부분*/
    const [Display, setDisplay] = useState('none');
    const [remainingHeight, setRemainingHeight] = useState(0);
    const handleHover = (height) => {
        setRemainingHeight(height);
        console.log('Received Remaining height:', height);
        setDisplay('block');
        console.log('Received Remaining height:', Display);
      };
      const handleHoverEnd = () => {
        console.log('Hover ended in MainComponent');
        setDisplay('none');
      };
    /*button 클릭 이벤트*/
    let data = [1, 2, 3]


    /*Button 테스트*/
    const [btnActive, setBtnActive] = useState('');

    function ShowButton(){
        const btn = btnActive === '' ? setBtnActive("Blue") : setBtnActive("Black")
        setBtnActive(btn);
    }

    /*Tab 전환 이벤트*/
    const location = useLocation();
    const activeIndex = location.state.activeIndex;
    const [activeTab, setActiveTab] = useState(activeIndex);
    console.log(activeTab);
    /*Tab 테두리 색상 변경 이벤트*/
    const [buttonBorders, setButtonBorders] = useState({button1:true, button2:false, button3:false});

    const handleClick = (buttonName, tabIndex) => {
        // setButtonBorders((prevBorders) => ({
        //   ...prevBorders,
        //   [buttonName]:!prevBorders[buttonName],
        // }));
        setButtonBorders({
            button1:false,
            button2:false,
            button3:false,
            [buttonName]:true,
        })
    
        setActiveTab(tabIndex);
      };

    // const handleBorderClick = (tabIndex) => {
    //     setButtonBorders((prevBorders) => ({
    //         ...prevBorders,
    //         [tabIndex]: !prevBorders[tabIndex],
    //       }));
    // }


     return (
         <div>
            {/* <header> <Header class = 'header1' onHover={handleHover} onHoverEnd={handleHoverEnd}/>
            <div style={{ zIndex:2, display:Display,position: 'fixed', bottom: 0, left: 0, right: 0, height:remainingHeight, backgroundColor:'black', width:'100%', opacity:0.6}}/>
            </header> */}
            {/* <Header onHover={handleHover} onHoverEnd={handleHoverEnd}/>
            <div style={{ zIndex:2, display:Display,position: 'fixed', bottom: 0, left: 0, right: 0, height:remainingHeight, backgroundColor:'black', width:'100%', opacity:0.6}}/>
            <div className='CompHeader'><img src={imgCompHeader}/></div> */}
            <div className='CompMain'>
                {/* <div className='Compparent1'> */}
                    <div className='CompBody1'>
                        <div className='CompHello'>사업소개?</div>
                        <div className='Comprectangle1'></div>
                    </div>
                    <div className='CompBody2'>
                        <div className='CompText1'>
                            <div className='BlueText'>S</div>
                            <div className='GrayText'>hipbuilding</div>&nbsp;&nbsp;&nbsp;
                            <div className='BlueText'>O</div>
                            <div className='GrayText'>ffshore</div>&nbsp;&nbsp;&nbsp;
                            <div className='BlueText'>TEC</div>
                            <div className='GrayText'>hnology</div>
                        </div>
                        <div className='CompText2'>조선, 해양 기술 분야의 토탈 솔루션을 제공하는 종합엔지니어링 회사입니다.</div>
                    </div>
                {/* </div> */}
                <div className='CompBody3'>
                    {/* {Object.keys(buttonBorders).map((tabIndex, index) => (
                            <button
                                className={"btn" + (data == btnActive ? "active" : "")}
                                key={index}
                                onClick={() => handleClick(tabIndex)}
                                style={{
                                    borderBottomColor: buttonBorders[tabIndex] ? '2px solid black' : '6px solid blue',
                                    // marginRight: 10+'px',
                                }}
                                >
                                {tabIndex}
                            </button>
                        ))} */}
                        <div style={{marginBottom:60+'px', display:'flex'}}>
                                <button className={"btnLine" + (activeTab == 1 ? " active" : "")} onClick={() => handleClick('button1',1)}>설계 및 기술지원</button>
                                <button className={"btnLine" + (activeTab == 2 ? " active" : "")} onClick={() => handleClick('button2',2)}>ICT 시스템 개발</button>
                                <button className={"btnLine" + (activeTab == 3 ? " active" : "")} onClick={() => handleClick('button3',3)}>공사 및 감리</button>
                        </div>
                        {activeTab === 1 && <div> {/* tab1의 내용 */}
                            <div className='main-frame1'>
                                <div className='imgSvessel'><img src={imgSvessel}></img></div>
                                <div className='sub-frame1'>
                                    <div className='sub-Svessel1'>SVESSEL OnBoard</div>
                                    <div className='sub-Svessel2'></div>
                                    <div className='sub-Svessel3'>일자리 창출 지원과 고용창출 우수 100대 기업으로 선정된 바 있는 당사는
                                                    대학과의 산학 협력을 통한 고용 창출 및 가족 친화 기업으로 인정 받아
                                                    일과 가정이 양립할 수 있으며 가족 구성원 모두 행복하고 즐거운 일터로
                                                    자리 잡아가고 있습니다.
                                    </div>
                                </div>
                            </div>
                            <div className='main-frame2'>
                                <div className='sub-frame3'>
                                    <div className='sub-Smartship1'>스마트십 개발</div>
                                    <div className='sub-Smartship2'></div>
                                    <div className='sub-Smartship3'>일자리 창출 지원과 고용창출 우수 100대 기업으로 선정된 바 있는 당사는
                                                    대학과의 산학 협력을 통한 고용 창출 및 가족 친화 기업으로 인정 받아
                                                    일과 가정이 양립할 수 있으며 가족 구성원 모두 행복하고 즐거운 일터로
                                                    자리 잡아가고 있습니다.
                                    </div>
                                </div>
                                <div className='imgSmartship'><img src={imgSmartship}></img></div>
                            </div>
                            <div className='main-frame3'>
                                <div className='imgTraffic'><img src={imgTraffic}></img></div>
                                <div className='sub-frame1'>
                                    <div className='sub-traffic1'>교통물류 시스템</div>
                                    <div className='sub-traffic2'></div>
                                    <div className='sub-traffic3'>일자리 창출 지원과 고용창출 우수 100대 기업으로 선정된 바 있는 당사는
                                                    대학과의 산학 협력을 통한 고용 창출 및 가족 친화 기업으로 인정 받아
                                                    일과 가정이 양립할 수 있으며 가족 구성원 모두 행복하고 즐거운 일터로
                                                    자리 잡아가고 있습니다.
                                    </div>
                                </div>
                            </div>
                        </div>}
                        {activeTab === 2 && <div> {/* tab2의 내용 */}
                            <div className='main-frame1'>
                                <div className='imgTraffic'><img src={imgTraffic}></img></div>
                                <div className='sub-frame1'>
                                    <div className='sub-traffic1'>교통물류 시스템</div>
                                    <div className='sub-traffic2'></div>
                                    <div className='sub-traffic3'>일자리 창출 지원과 고용창출 우수 100대 기업으로 선정된 바 있는 당사는
                                                    대학과의 산학 협력을 통한 고용 창출 및 가족 친화 기업으로 인정 받아
                                                    일과 가정이 양립할 수 있으며 가족 구성원 모두 행복하고 즐거운 일터로
                                                    자리 잡아가고 있습니다.
                                    </div>
                                </div>
                            </div>
                            <div className='main-frame2'>
                                <div className='sub-frame3'>
                                    <div className='sub-Smartship1'>스마트십 개발</div>
                                    <div className='sub-Smartship2'></div>
                                    <div className='sub-Smartship3'>일자리 창출 지원과 고용창출 우수 100대 기업으로 선정된 바 있는 당사는
                                                    대학과의 산학 협력을 통한 고용 창출 및 가족 친화 기업으로 인정 받아
                                                    일과 가정이 양립할 수 있으며 가족 구성원 모두 행복하고 즐거운 일터로
                                                    자리 잡아가고 있습니다.
                                    </div>
                                </div>
                                <div className='imgSmartship'><img src={imgSmartship}></img></div>
                            </div>
                            <div className='main-frame3'>
                                <div className='imgSvessel'><img src={imgSvessel}></img></div>
                                <div className='sub-frame1'>
                                    <div className='sub-Svessel1'>SVESSEL OnBoard</div>
                                    <div className='sub-Svessel2'></div>
                                    <div className='sub-Svessel3'>일자리 창출 지원과 고용창출 우수 100대 기업으로 선정된 바 있는 당사는
                                                    대학과의 산학 협력을 통한 고용 창출 및 가족 친화 기업으로 인정 받아
                                                    일과 가정이 양립할 수 있으며 가족 구성원 모두 행복하고 즐거운 일터로
                                                    자리 잡아가고 있습니다.
                                    </div>
                                </div>
                            </div>
                        </div>}
                        {activeTab === 3 && <div> {/* tab3의 내용 */}
                            <div className='main-frame1'>
                                <div className='imgSvessel'><img src={imgSvessel}></img></div>
                                <div className='sub-frame1'>
                                    <div className='sub-traffic1'>교통물류 시스템</div>
                                    <div className='sub-traffic2'></div>
                                    <div className='sub-traffic3'>일자리 창출 지원과 고용창출 우수 100대 기업으로 선정된 바 있는 당사는
                                                    대학과의 산학 협력을 통한 고용 창출 및 가족 친화 기업으로 인정 받아
                                                    일과 가정이 양립할 수 있으며 가족 구성원 모두 행복하고 즐거운 일터로
                                                    자리 잡아가고 있습니다.
                                    </div>
                                </div>
                            </div>
                            <div className='main-frame2'>
                                <div className='sub-frame3'>
                                    <div className='sub-Smartship1'>스마트십 개발</div>
                                    <div className='sub-Smartship2'></div>
                                    <div className='sub-Smartship3'>일자리 창출 지원과 고용창출 우수 100대 기업으로 선정된 바 있는 당사는
                                                    대학과의 산학 협력을 통한 고용 창출 및 가족 친화 기업으로 인정 받아
                                                    일과 가정이 양립할 수 있으며 가족 구성원 모두 행복하고 즐거운 일터로
                                                    자리 잡아가고 있습니다.
                                    </div>
                                </div>
                                <div className='imgSmartship'><img src={imgSmartship}></img></div>
                            </div>
                            <div className='main-frame3'>
                                <div className='imgTraffic'><img src={imgTraffic}></img></div>
                                <div className='sub-frame1'>
                                    <div className='sub-Svessel1'>SVESSEL OnBoard</div>
                                    <div className='sub-Svessel2'></div>
                                    <div className='sub-Svessel3'>일자리 창출 지원과 고용창출 우수 100대 기업으로 선정된 바 있는 당사는
                                                    대학과의 산학 협력을 통한 고용 창출 및 가족 친화 기업으로 인정 받아
                                                    일과 가정이 양립할 수 있으며 가족 구성원 모두 행복하고 즐거운 일터로
                                                    자리 잡아가고 있습니다.
                                    </div>
                                </div>
                            </div>
                        </div>}
                </div>

            </div>
            {/* <div className='CompFooter'><img src={imgCompFooter}/></div> */}
            {/* <Footer /> */}
         </div>
     );
 }

 export default CompInfo;